import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CarCard } from "@/components/CarCard";
import { Seo } from "@/components/Seo";
import { PaymentNotice } from "@/components/PaymentNotice";
import { RentalFeatures } from "@/components/RentalFeatures";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2 } from "lucide-react";

export default function Fleet() {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [transmission, setTransmission] = useState("all");
  const [fuel, setFuel] = useState("all");
  const [cfg, setCfg] = useState(null);
  useEffect(() => { api.get("/config").then((r) => setCfg(r.data)).catch(() => {}); }, []);

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (transmission !== "all") params.transmission = transmission;
    if (fuel !== "all") params.fuel = fuel;
    api.get("/cars", { params })
      .then((r) => setCars(r.data))
      .finally(() => setLoading(false));
  }, [transmission, fuel]);

  return (
    <div className="min-h-screen bg-background grain" data-testid="fleet-page">
      <Seo title="Noleggio Auto a Pontedera — Parco Auto | Centro Auto Pontedera" description="Scopri il parco auto a noleggio a Pontedera (PI): Fiat Panda ibrida e Alfa Romeo Junior. Prenota online, paga al ritiro o con carta, cauzione trasparente e rimborsabile." path="/cars" />
      <Navbar />
      <div className="max-w-7xl mx-auto px-6 pt-32 pb-10">
        <div className="font-mono-tech text-xs tracking-[0.3em] uppercase amber mb-3">Parco Auto</div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight uppercase">Scegli la tua auto</h1>
        <PaymentNotice cfg={cfg} className="mt-8" />
        <div className="flex flex-wrap gap-4 mt-8">
          <Select value={transmission} onValueChange={setTransmission}>
            <SelectTrigger className="w-44 bg-[#181A22] border-white/10" data-testid="filter-transmission"><SelectValue placeholder="Cambio" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tutti i cambi</SelectItem>
              <SelectItem value="Automatico">Automatico</SelectItem>
              <SelectItem value="Manuale">Manuale</SelectItem>
            </SelectContent>
          </Select>
          <Select value={fuel} onValueChange={setFuel}>
            <SelectTrigger className="w-44 bg-[#181A22] border-white/10" data-testid="filter-fuel"><SelectValue placeholder="Carburante" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tutti i carburanti</SelectItem>
              <SelectItem value="Benzina">Benzina</SelectItem>
              <SelectItem value="Diesel">Diesel</SelectItem>
              <SelectItem value="Ibrida">Ibrida</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 pb-20">
        {loading ? (
          <div className="flex justify-center py-32"><Loader2 className="w-8 h-8 animate-spin text-[#E63946]" /></div>
        ) : cars.length === 0 ? (
          <div className="text-center py-32 text-muted-foreground">Nessuna auto disponibile con questi filtri.</div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="cars-grid">
            {cars.map((c, i) => <CarCard key={c.id} car={c} index={i} />)}
          </div>
        )}
      </div>
      <RentalFeatures />
      <Footer />
    </div>
  );
}
